import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {connect} from 'react-redux';
import InstallationGroupItemsPageHeader from './InstallationGroupItemsPageHeader.rt';
import { EditorFooter as InstallationGroupItemsPageFooter } from '../../PageLayout';
import template from './InstallationGroupItems.rt';
import * as actions from '../../../actions';
import {
  selectSearchTerm
} from '../../../selectors';
import {
  getActiveInstallationGroupEnabledFilteredInstallations,
  getActiveInstallationGroupDisabledFilteredInstallations,
  getActiveInstallationGroup
} from '../InstallationSelector';
import * as editorNames from '../../../constants/editorNames';
import { fetchData } from '../../ProjectScope/ProjectScopeActions';
import {hashHistory} from 'react-router';
import Cookies from 'cookies-js';

function mapStateToProps(state, props) {
  let group = getActiveInstallationGroup(state) || {};
  return {
    group: group.featureGroup || Cookies.get("selected-active-installation-groupName"),
    activeInstallationGroup: group,
    enabledInstallations: getActiveInstallationGroupEnabledFilteredInstallations(state),
    disabledInstallations: getActiveInstallationGroupDisabledFilteredInstallations(state),
    term: selectSearchTerm(state)
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    fetchFabricator: (group) => dispatch(fetchData(`group${group}`)),
    loadFeatureInclusionPresets: () => dispatch(actions.FeatureInclusion.loadPreset()),
    setSearchTerm: (term) => dispatch(actions.setSearchTerm(term)),
    onLoadEditor: (name) => dispatch(actions.loadEditor(name)),
    onUnloadEditor: () => dispatch(actions.unloadEditor())
  };
}

class InstallationGroupItems extends PureComponent {
  _forceUpdate = () => this.forceUpdate();
  componentWillMount() {
    this.props.onLoadEditor(editorNames.INSTALLATION_CREATOR);
    this.props.fetchFabricator(' "' + (this.props.activeInstallationGroup.customDisplayName || this.props.group) + '"');
    document.addEventListener('save-installation-complete', this._forceUpdate);
  }

  componentWillUnmount() {
    this.props.setSearchTerm('');
    this.props.onUnloadEditor();
    document.removeEventListener('save-installation-complete', this._forceUpdate);
  }

  render = template
}

InstallationGroupItems.propTypes = InstallationGroupItemsPageHeader.propTypes = InstallationGroupItemsPageFooter.propTypes = {
  group: PropTypes.string
};

const connector = connect(mapStateToProps, mapDispatchToProps);
const InstallationGroupItemsContainer = connector(InstallationGroupItems);
const InstallationGroupItemsPageHeaderContainer = connector(InstallationGroupItemsPageHeader);
const InstallationGroupItemsPageFooterContainer = connector(InstallationGroupItemsPageFooter);

export {
  InstallationGroupItems,
  InstallationGroupItemsContainer,
  InstallationGroupItemsPageHeaderContainer,
  InstallationGroupItemsPageHeader,
  InstallationGroupItemsPageFooter,
  InstallationGroupItemsPageFooterContainer
};
